module.exports = __webpack_public_path__ + "static/media/ocean-mobile.1bff9e7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ocean-mobile.mp4
// module id = Qoyf
// module chunks = 1